/* eslint-disable no-useless-escape */
import { Buffer } from "buffer/";
import { IEditableModuleStates, IModuleList, IRawModuleList } from "@src/types";

/**
 * Changes the visibility of module divs
 * @param  css The css to inject into the DOM
 */
export function applyPreviewStyles(css: string): void {
    const style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);
}

/**
 * Parses raw module data from API response
 * @param rawModules Raw module data from API
 * @returns Parsed modules and editable states
 */
export function parseModulesFromResponse(rawModules: IRawModuleList): {
    modules: IModuleList;
    editableModules: IEditableModuleStates;
} {
    const editableModules: IEditableModuleStates = {};
    const modules: IModuleList = {};

    for (let module in rawModules) {
        modules[module] = {
            baseHtml: rawModules[module].base_html,
            currentHtml: rawModules[module].current_html,
            default: rawModules[module].default,
            name: rawModules[module].name,
        };
    }

    for (let module in modules) {
        editableModules[module] = { editable: false };

        if (modules[module].baseHtml.includes("MODULETABLE")) {
            var newHtml = modules[module].baseHtml.replace(
                "MODULETABLE",
                module + "TABLE"
            );
            modules[module].baseHtml = newHtml;
            modules[module].currentHtml = newHtml;
        }
    }

    return { modules, editableModules };
}

/**
 * Converts module data to raw format for API submission
 * @param moduleData The module data to convert
 * @returns Base64 encoded module data
 */
export function prepareModulesForSave(moduleData: IModuleList): string {
    const requestBody: IRawModuleList = {};
    for (let module in moduleData) {
        const {baseHtml, currentHtml, default: defaultVal, name} = moduleData[module];

        requestBody[module] = {
            base_html: baseHtml,
            current_html: currentHtml,
            default: defaultVal,
            name: name,
        };
    }

    const requestBodyString = JSON.stringify(requestBody);
    return Buffer.from(requestBodyString).toString("base64");
}

/**
 * Downloads a PDF from base64 encoded buffer
 * @param encoded_buffer Base64 encoded PDF buffer
 * @param doc_type Document type for filename
 */
export function downloadPdf(encoded_buffer: string, doc_type: string): void {
    const pdf_buffer = Buffer.from(encoded_buffer, "base64");
    const file = new Blob([pdf_buffer], { type: "application/pdf" });
    var fileURL = URL.createObjectURL(file);
    var link = document.createElement("a");
    link.href = fileURL;
    link.download = doc_type + ".pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

/**
 * Extracts the variables from the html
 * @param  html The html to extract the variables from
 * @return An array of variables
 */
export function findVariables(html: string) {
    const regexp = /<span class=['"]VARIABLE_([^<>]*)['"]/g;
    const matches = [...html.matchAll(regexp)];

    var twigVars = new Set<string>();
    for (let match in matches) {
        twigVars.add(matches[match][1]);
    }

    return Array.from(twigVars);
}
